import Tables from '@/component/Tables';
import { NoDataContent } from '@/page/history/components/NoData';
import { getLoyaltyPointHistory } from '@/Redux/futures/loyalty-point/actions';
import { formatDataNumberToen } from '@/utils/helper';
import frameBottom from '@assets/web-v3-images/Frame-bottom.png';
import frameCenter from '@assets/web-v3-images/Frame-center.png';
import frameTop from '@assets/web-v3-images/Frame-top.png';
import { Table, Text } from '@radix-ui/themes';
import { formatHistoryDate } from "@/page/history/formatDate";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export default function LoyaltyPointHistory() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [dataResApi, setdataResApi] = useState(null);
	const [page, setPage] = useState(1);

	const getHistory = (data, isLoading) => {
		if (data) {
			setdataResApi(data);
		}
	};

	const getHistoryLoyaltyPage = () => {
		const body = {
			query: {
				limit: 5,
				page: page,
			},
			callback: getHistory,
		};
		dispatch(getLoyaltyPointHistory(body));
	};

	useEffect(() => {
		getHistoryLoyaltyPage();
	}, [page]);

	const columns = [
		{ key: "source", title: t('loyalty_point.source') },
		{ key: "amount", title: t("loyalty_point.amount") },
	];

	return (
		<div className="flex flex-col w-full relative">
			{/* Top cap - cố định, không lặp */}
			<img src={frameTop} alt="" className="w-full block select-none" draggable={false} />

			{/* Phần giữa - co giãn theo nội dung */}
			<div
				className="w-full flex-1 px-6 sm:px-10 py-2 -mt-1"
				style={{
					backgroundImage: `url(${frameCenter})`,
					backgroundRepeat: 'repeat-y',
					backgroundSize: '100% 100%',
				}}
			>
				<Text className="absolute left-1/2 top-[5%] -translate-x-1/2 -translate-y-1/2 text-[27px] font-bold text-[#7A2E0E]">
					{t('loyalty_point.loyalty_point_history')}
				</Text>
				<>
					{dataResApi && dataResApi?.data?.length === 0 ?
						<div className='px-20 flex flex-col justify-center items-center min-h-[670px]'>
							<NoDataContent
								title={t('loyalty_point.no_history_yet')}
							/>
						</div>
						:
						<Tables
							classNames="min-h-[670px]"
							classNamePaginations="!p-0 pt-5"
							current={page}
							onChange={(p) => setPage(p)}
							pagination={true}
							columns={columns}
							data={dataResApi?.data}
							rowKey={(item) => `${item.transaction_type}-${item.id}`}
							totalPages={Math.ceil((dataResApi?.total || 0) / Number(dataResApi?.limit || 1))}
							renderRow={(item) => (
								<Table.Row key={`${item.transaction_type}-${item.id}-${item?.key}`}>
									<Table.Cell>
										<div className="flex items-center h-full text-left gap-1">
											<div className="flex flex-col w-[350px] shrink-0">
												<Text className="font-semibold text-[rgba(113,59,18,1)]">{item.source_label}</Text>
												<Text className="font-medium text-[rgba(161,92,7,1)] text-[19px] italic">
													{item?.transaction_type === 'EARN' ? (
														<>
															{formatHistoryDate(item?.transaction_time)}
															<br />
															{t('loyalty_point.expires')} {formatHistoryDate(item?.batch_expire_time)}
														</>
													) : (
														formatHistoryDate(item?.transaction_time)
													)}
												</Text>
											</div>
										</div>
									</Table.Cell>
									<Table.Cell>
										<div className="flex items-center h-full text-left gap-1">
											<div className="flex flex-col w-[280px] shrink-0">
												<Text className='flex items-center h-full text-left font-semibold text-[rgba(113,59,18,1)]'>
													{item?.transaction_type === 'EARN' ? "+" : "-"}	{formatDataNumberToen(item.amount)} LP
												</Text>
												<Text className="font-medium text-[rgba(161,92,7,1)] text-[19px] italic">
													{t('loyalty_point.balance')} {formatDataNumberToen(item?.balance_after || 0)}
												</Text>
											</div>
										</div>
									</Table.Cell>
								</Table.Row>
							)}
						/>
					}
				</>
			</div>
			{/* Bottom cap - cố định, không lặp */}
			<img src={frameBottom} alt="" className="w-full block select-none -mt-1" draggable={false} />
		</div>
	)
}